// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
:host ion-header {
  position: relative;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  --box-shadow: none;
  box-shadow: none;
  background: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  --background: transparent;
}
:host ion-header:after {
  display: none;
}
:host ion-header ion-toolbar {
  --background: transparent;
  --border-width: 0px;
  color: var(--ion-color-secondary);
  --min-height: 40px;
  --padding-bottom: 5px;
  --padding-top: 5px;
  --padding-start: 20px;
  --padding-end: 15px;
  --box-shadow: none;
  position: relative;
}
:host ion-header ion-toolbar ion-buttons {
  margin: 0;
}
:host ion-header ion-toolbar ion-buttons ion-button {
  margin: 0;
  --background: transparent;
  box-shadow: none;
  --background-focused: transparent;
  --background-focused-opacity: 0;
  --background-hover: transparent;
  --background-hover-opacity: 0;
  --background-activated: transparent;
  --background-activated-opacity: 0;
  --border-radius: 0;
  border-radius: 0;
  --color: var(--ion-color-secondary);
  --padding-end: 0;
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: 0;
  font-size: 24px;
}
:host ion-header ion-toolbar ion-buttons ion-button .menu-btn {
  position: relative;
}
:host ion-header ion-toolbar ion-buttons ion-back-button {
  --color: rgba(var(--ion-color-secondary-rgb), 0.9);
}
:host ion-header ion-toolbar ion-title {
  text-align: center;
  font-size: 1.3333333333rem;
  font-weight: 600;
  position: absolute;
  left: 50%;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 200px;
  line-height: 1.5;
}
:host ion-header ion-toolbar ion-title.logo {
  position: absolute;
  left: 50%;
  right: 0;
  top: 50%;
  padding: 0;
  transform: translate(-50%, -50%);
}
:host ion-header ion-toolbar ion-title.logo img {
  max-width: 7.2777777778rem;
  height: auto;
  display: inline-block;
}
:host ion-header.greyHeader {
  background: var(--ion-color-light-shade);
  --background: var(--ion-color-light-shade);
}
:host ion-content {
  --padding-top: 0;
  --offset-bottom: -100px;
}

:host ion-header {
  background: var(--bg-app);
  --background: var(--bg-app);
  padding-bottom: 10px;
  font-family: var(--ion-font-family-secondary);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
:host ion-header ion-toolbar {
  background: transparent;
}
:host ion-header ion-toolbar ion-title {
  min-width: calc(100% - 60px);
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}
:host ion-header ion-toolbar ion-title h4 {
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 0;
  text-wrap: wrap;
  text-align: left;
  color: var(--text-primary-token);
}
:host ion-content {
  --background: var(--bg-app);
  position: relative;
  z-index: 1;
  overflow: auto;
  --padding-bottom: 80px;
  --padding-top: 20px;
  --padding-start: 10px;
  --padding-end: 10px;
}
:host ion-content ion-toolbar {
  --background: transparent;
  --border-width: 0px;
  color: var(--text-primary-token);
  --box-shadow: none;
}
:host ion-content ion-toolbar.cross-header {
  position: absolute;
  right: 10px;
  top: 15px;
  z-index: 999;
}
:host ion-content ion-toolbar ion-buttons ion-button {
  --background: transparent;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  --background-focused: var(--ion-color-primary-grad);
  --background-focused-opacity: 1;
  --background-hover: var(--ion-color-primary-grad);
  --background-hover-opacity: 1;
  --border-radius: 14px;
  border-radius: 14px;
  --color: var(--ion-color-secondary);
  --padding-bottom: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-bottom: 0;
  width: 45px;
  height: 43px;
}
:host ion-content .auth-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background: transparent;
  overflow: auto;
  position: relative;
  z-index: 199;
}
:host ion-content .auth-content ion-card {
  min-height: 480px;
  height: auto;
  padding-top: 1.1111111111rem;
  margin: 0px;
  max-width: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  box-shadow: none;
  --background: transparent;
  border-radius: 0;
}
:host ion-content .auth-content ion-card .title h4 {
  color: var(--ion-color-medium);
  font-family: var(--ion-font-family);
  margin: 0 0 30px;
  text-transform: capitalize;
  color: rgba(var(--ion-color-secondary-rgb), 1);
  --height: auto;
}
:host ion-content .auth-content form {
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  background: transparent;
}
:host ion-content .auth-content form ion-list {
  background: transparent;
  margin-bottom: 20px;
}
:host ion-content .auth-content form ion-item {
  border: 1px solid transparent;
  border-bottom-color: rgba(var(--ion-color-dark-rgb), 0.2);
  border-radius: 0px;
  --background: transparent;
  --inner-padding-bottom: 0;
  --padding-bottom: 0;
  --inner-padding-top: 0;
  --padding-top: 0;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
  --min-height: 50px;
  margin: 0 0 10px;
  --border-color: transparent;
}
:host ion-content .auth-content form ion-item.item-has-focus, :host ion-content .auth-content form ion-item.item-has-value {
  border-bottom-color: rgba(var(--ion-color-primary-rgb), 1);
  --highlight-background: rgba(var(--ion-color-primary-rgb), 1);
}
:host ion-content .auth-content form ion-item.item-has-focus ion-label, :host ion-content .auth-content form ion-item.item-has-value ion-label {
  margin-top: 0;
  color: rgba(var(--ion-color-primary-rgb), 1);
}
:host ion-content .auth-content form ion-item.ion-invalid {
  --highlight-background: var(ion-color-danger);
}
:host ion-content .auth-content form ion-item ion-input {
  --background: transparent;
  --color: #000;
  --inner-padding-bottom: 0;
  --padding-bottom: 0;
  --padding-top: 0px;
  --inner-padding-top: 0;
  margin: 0;
  --placeholder-color: rgba(var(--ion-color-dark), 0.3);
}
:host ion-content .auth-content form ion-item ion-label {
  --color: rgba(var(--ion-color-dark-rgb), 0.6);
  --inner-padding-bottom: 0;
  --padding-bottom: 0;
  --inner-padding-top: 0;
  --padding-top: 0;
  margin-top: 0;
  line-height: 1.3;
}
:host ion-content .auth-content form shc-validation-messages {
  margin-top: 0;
  margin-bottom: 0.8333333333rem;
  font-size: 0.7777777778rem;
}
:host ion-content .auth-content form ion-toolbar {
  --min-height: 80px;
}
:host ion-content .auth-content form ion-toolbar ion-title {
  padding: 0;
  width: auto;
}
:host ion-content .auth-content form ion-toolbar ion-title h3 {
  margin: 0;
  line-height: 1.3;
}
:host ion-alert {
  background: var(--bg-app);
  --background: var(--bg-app);
  --background-color: var(--bg-app);
  --ion-background-color: var(--bg-app);
}

ion-footer {
  position: absolute;
  bottom: 0;
  background: var(--bg-app);
  background-position: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}
@media screen and (min-width: 992px) {
  ion-footer {
    --background: transparent;
    background: transparent;
  }
}
ion-footer ion-button.theme-btn {
  max-width: 463px;
  margin: 16px auto;
}
@media (max-width: 575px) {
  ion-footer ion-button.theme-btn {
    margin: 16px 10px;
  }
}

.shipping-method {
  --color: #000;
}

.select-icon {
  display: none;
}

/* global.scss or component.scss */
::ng-deep .custom-shipping-alert {
  --border-color: ;
}

::ng-deep ion-alert .alert-wrapper {
  border-radius: 16px;
  background-color: #ffffff;
  --background: #ffffff;
  padding: 10px;
}

::ng-deep .custom-shipping-alert .alert-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

::ng-deep .custom-shipping-alert .alert-radio-label {
  font-size: 16px;
  color: #222;
  display: flex;
  justify-content: space-between;
}

::ng-deep .custom-shipping-alert .alert-radio-inner {
  background: var(--ion-color-primary);
}

::ng-deep .custom-shipping-alert .alert-button {
  font-weight: bold;
  color: var(--ion-color-primary);
}

/* In your component.scss */
::ng-deep ion-alert {
  --ion-color-step-850: #262626;
  --ion-color-light-shade: #fffffff;
  background: var(--ion-color-light-shade);
  --background: var(--ion-color-light-shade);
}
::ng-deep ion-alert .shipping-method .alert-radio-label.sc-ion-alert-md {
  padding-inline-start: 35px;
  font-size: 14px;
  line-height: 18px;
}

ion-select::part(icon) {
  display: none; /* hide the icon */
}

ion-select {
  --border-color: transparent;
}

::ng-deep .custom-country-alert .alert-wrapper {
  border-radius: 16px;
}

::ng-deep .custom-country-alert .alert-radio-inner {
  background: var(--ion-color-primary);
}

::ng-deep .custom-country-alert .alert-radio-label {
  font-size: 15px;
  color: #222;
}

::ng-deep .custom-country-alert .alert-radio-icon {
  border-color: var(--ion-color-primary);
}

::ng-deep .custom-country-alert .alert-button {
  font-weight: bold;
  color: var(--ion-color-primary);
}

.pill-field {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--surface-card);
  border-radius: 14px;
  padding: 6px 16px;
  min-height: 52px;
}

.pill-field--smart {
  border: 1.5px solid var(--brand);
  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));
}

.pill-label {
  position: absolute;
  top: 6px;
  left: 16px;
  font-size: 11px;
  color: var(--text-secondary-token);
}

.pill-label--smart {
  color: var(--brand);
}

.pill-input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  padding-top: 16px;
  font-size: 15px;
  color: var(--text-primary-token);
}

.pill-chevron {
  font-size: 16px;
  color: var(--text-secondary-token);
}

.postal-house-row {
  display: flex;
  gap: 10px;
}
.postal-house-row .pill-field {
  flex: 1;
}

.pill-hint {
  font-size: 11px;
  color: var(--text-muted-token);
  margin: -6px 0 10px 4px;
}

.shipping-methods-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary-token);
  margin-bottom: 8px;
}

.shipping-method-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.5px solid var(--border-token);
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 8px;
  cursor: pointer;
}

.shipping-method-card--selected {
  border: 1.5px solid var(--brand);
  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));
}

.shipping-method-name {
  font-size: 14px;
  color: var(--text-primary-token);
}

.shipping-method-price {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary-token);
}

.shipping-summary {
  --background: transparent;
  font-size: 12px;
  color: var(--text-secondary-token);
}

.cost-breakdown {
  padding: 4px 16px 0;
}
.cost-breakdown .cost-breakdown-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #777777;
  padding: 2px 0;
}
.cost-breakdown .cost-breakdown-row.cost-breakdown-total {
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A;
  margin-top: 4px;
  padding-top: 6px;
  border-top: 0.5px solid #ECECEC;
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./src/app/components/buyer-shipping-address-payment/buyer-shipping-address-payment.component.scss","webpack://./src/assets/CustomCss/custom-header.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACdJ;;ADiBA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AClBJ;;AD+BA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;AC5BF;;AD+BA;;;;;;;;;;;;;;;;CAAA;AAxMA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACiLJ;;AD9KA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AC6KJ;;ADhKA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;ACmKF;;ADhKA;;;;;;;;;;;;;;;;CAAA;AExME;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AD4XJ;AC3XI;EACE,aAAA;AD6XN;AC3XI;EACE,yBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD6XN;AC5XM;EACE,SAAA;AD8XR;AC7XQ;EACE,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AD+XV;AC1XU;EACE,kBAAA;AD4XZ;ACzXQ;EACE,kDAAA;AD2XV;ACxXM;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AD0XR;ACzXQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;AD2XV;AC1XU;EACE,0BAAA;EACA,YAAA;EACA,qBAAA;AD4XZ;ACvXI;EACE,wCAAA;EACA,0CAAA;ADyXN;ACxRE;EACE,gBAAA;EACA,uBAAA;AD0RJ;;AAldE;EACE,yBAAA;EACA,2BAAA;EACA,oBAAA;EACA,6CAAA;EACA,gHAAA;AAqdJ;AApdI;EACE,uBAAA;AAsdN;AArdM;EACE,4BAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;AAudR;AAtdQ;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAwdV;AAndE;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAqdJ;AApdI;EACE,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AAsdN;AArdM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAudR;AApdQ;EACE,yBAAA;EACA,4CAAA;EACA,mDAAA;EACA,+BAAA;EACA,iDAAA;EACA,6BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAsdV;AAldI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAodN;AAndM;EACE,iBAAA;EACA,YAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAqdR;AAndU;EACE,8BAAA;EACA,mCAAA;EACA,gBAAA;EACA,0BAAA;EACA,8CAAA;EACA,cAAA;AAqdZ;AAjdM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;AAmdR;AAldQ;EACE,uBAAA;EACA,mBAAA;AAodV;AAldQ;EACE,6BAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAodV;AAndU;EAEE,0DAAA;EACA,6DAAA;AAodZ;AAndY;EACE,aAAA;EACA,4CAAA;AAqdd;AAldU;EACE,6CAAA;AAodZ;AAldU;EACE,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,qDAAA;AAodZ;AAldU;EACE,6CAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAodZ;AAjdQ;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;AAmdV;AAjdQ;EACE,kBAAA;AAmdV;AAldU;EACE,UAAA;EACA,WAAA;AAodZ;AAndY;EACE,SAAA;EACA,gBAAA;AAqdd;AA9cE;EACE,yBAAA;EACA,2BAAA;EACA,iCAAA;EACA,qCAAA;AAgdJ;;AA7cA;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,4BAAA;AAgdF;AEjlBI;EF2HJ;IAQI,yBAAA;IACA,uBAAA;EAkdF;AACF;AAhdI;EACE,gBAAA;EACA,iBAAA;AAkdN;AA/cE;EAEI;IACE,iBAAA;EAgdN;AACF;;AA5cA;EACE,aAAA;AA+cF;;AA7cA;EACE,aAAA;AAgdF;;AA9cA,kCAAA;AACA;EACE,gBAAA;AAidF;;AA/cA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;AAkdF;;AA/cA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAkdF;;AA/cA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AAkdF;;AA/cA;EACE,oCAAA;AAkdF;;AA/cA;EACE,iBAAA;EACA,+BAAA;AAkdF;;AAhdA,2BAAA;AACA;EACE,6BAAA;EACA,iCAAA;EACA,wCAAA;EACF,0CAAA;AAmdA;AAhdM;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;AAkdR;;AA3cA;EACE,aAAA,EAAA,kBAAA;AA8cF;;AA5cA;EACE,2BAAA;AA+cF;;AA5cA;EACE,mBAAA;AA+cF;;AA5cA;EACE,oCAAA;AA+cF;;AA5cA;EACE,eAAA;EACA,WAAA;AA+cF;;AA5cA;EACE,sCAAA;AA+cF;;AA5cA;EACE,iBAAA;EACA,+BAAA;AA+cF;;AA3cA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA8cF;;AA5cA;EACE,gCAAA;EACA,oEAAA;AA+cF;;AA7cA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,kCAAA;AAgdF;;AA9cA;EACE,mBAAA;AAidF;;AA/cA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AAkdF;;AAhdA;EACE,eAAA;EACA,kCAAA;AAmdF;;AAjdA;EACE,aAAA;EACA,SAAA;AAodF;AAndE;EACE,OAAA;AAqdJ;;AAldA;EACE,eAAA;EACA,8BAAA;EACA,uBAAA;AAqdF;;AAndA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AAsdF;;AApdA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAudF;;AArdA;EACE,gCAAA;EACA,oEAAA;AAwdF;;AAtdA;EACE,eAAA;EACA,gCAAA;AAydF;;AAvdA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AA0dF;;AAxdA;EACE,yBAAA;EACA,eAAA;EACA,kCAAA;AA2dF;;AAxdA;EACE,mBAAA;AA2dF;AAzdE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AA2dJ;AAzdI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AA2dN","sourcesContent":["// Ionic Variables and Theming. For more info, please see:\n// http://ionicframework.com/docs/theming/\n\n/** Ionic CSS Variables **/\n\n:root {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #007AFF;\n    --ion-color-tertiary-rgb: 0, 122, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #006be0;\n    --ion-color-tertiary-tint: #1a87ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    //__________________//\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    // Spacing\n    --app-padding-from-top: 30px;\n}\n\n.ios body,\n.md body {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #5260ff;\n    --ion-color-tertiary-rgb: 82, 96, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #4854e0;\n    --ion-color-tertiary-tint: #6370ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    ////////////\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    //////////\n    //////////\n    // ////////\n    --ion-background-color: var(--ion-color-light);\n    --ion-background-color-rgb: var(--ion-color-light-rgb);\n    --ion-text-color: var(--ion-color-dark);\n    --ion-text-color-rgb: var(--ion-color-dark-rgb);\n    --ion-color-step-50: #0d0d0d;\n    --ion-color-step-100: #1a1a1a;\n    --ion-color-step-150: #262626;\n    --ion-color-step-200: #333333;\n    --ion-color-step-250: #404040;\n    --ion-color-step-300: #4d4d4d;\n    --ion-color-step-350: #595959;\n    --ion-color-step-400: #666666;\n    --ion-color-step-450: #737373;\n    --ion-color-step-500: #808080;\n    --ion-color-step-550: #8c8c8c;\n    --ion-color-step-600: #999999;\n    --ion-color-step-650: #a6a6a6;\n    --ion-color-step-700: #b3b3b3;\n    --ion-color-step-750: #bfbfbf;\n    --ion-color-step-800: #cccccc;\n    --ion-color-step-850: #d9d9d9;\n    --ion-color-step-900: #e6e6e6;\n    --ion-color-step-950: #f2f2f2;\n    --ion-item-background: transparent;\n    --ion-card-background: #fff;\n    /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n    @media (prefers-color-scheme: dark) {\n        --ion-background-color: #17171A;\n        --ion-background-color-rgb: 23, 23, 26;\n        --ion-text-color: #F2F2F2;\n        --ion-text-color-rgb: 242, 242, 242;\n        color: var(--ion-text-color);\n        background: var(--ion-background-color);\n    }\n    */\n}\n\n// --- Stijlgids-tokens (modernisatietraject, licht/donker via prefers-color-scheme) ---\n:root {\n  --brand: #E82973;\n  --bg-app: #FFFFFF;\n  --surface-card: #F5F5F5;\n  --border-token: #E5E5E5;\n  --text-primary-token: #1A1A1A;\n  --text-secondary-token: #777777;\n  --text-muted-token: #999999;\n}\n\n/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n@media (prefers-color-scheme: dark) {\n  :root {\n    --brand: #E82973;\n    --bg-app: #17171A;\n    --surface-card: #3F3F45;\n    --border-token: #3A3A3D;\n    --text-primary-token: #F2F2F2;\n    --text-secondary-token: #A0A0A5;\n    --text-muted-token: #6E6E73;\n    --ion-background-color: #17171A;\n    --ion-background-color-rgb: 23, 23, 26;\n    --ion-text-color: #F2F2F2;\n    --ion-text-color-rgb: 242, 242, 242;\n  }\n}\n*/\n","@import \"../../../theme/variables.scss\";\n@import \"../../../theme/mixins.scss\";\n@import \"../../../assets/CustomCss/custom-header.scss\";\n:host {\n  ion-header {\n    background: var(--bg-app);\n    --background: var(--bg-app);\n    padding-bottom: 10px;\n    font-family: var(--ion-font-family-secondary);\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);\n    ion-toolbar {\n      background: transparent;\n      ion-title {\n        min-width: calc(100% - 60px);\n        left: 0;\n        top: 50%;\n        transform: translate(0, -50%);\n        h4 {\n          font-size: 16px;\n          margin-top: 0;\n          margin-bottom: 0;\n          text-wrap: wrap;\n          text-align: left;\n          color: var(--text-primary-token);\n        }\n      }\n    }\n  }\n  ion-content {\n    --background: var(--bg-app);\n    position: relative;\n    z-index: 1;\n    overflow: auto;\n    --padding-bottom: 80px;\n    --padding-top: 20px;\n    --padding-start: 10px;\n    --padding-end: 10px;\n    ion-toolbar {\n      --background: transparent;\n      --border-width: 0px;\n      color: var(--text-primary-token);\n      --box-shadow: none;\n      &.cross-header {\n        position: absolute;\n        right: 10px;\n        top: 15px;\n        z-index: 999;\n      }\n      ion-buttons {\n        ion-button {\n          --background: transparent;\n          box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);\n          --background-focused: var(--ion-color-primary-grad);\n          --background-focused-opacity: 1;\n          --background-hover: var(--ion-color-primary-grad);\n          --background-hover-opacity: 1;\n          --border-radius: 14px;\n          border-radius: 14px;\n          --color: var(--ion-color-secondary);\n          --padding-bottom: 0;\n          --padding-top: 0;\n          --padding-bottom: 0;\n          --padding-bottom: 0;\n          width: 45px;\n          height: 43px;\n        }\n      }\n    }\n    .auth-content {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: flex-start;\n      background: transparent;\n      overflow: auto;\n      position: relative;\n      z-index: 199;\n      ion-card {\n        min-height: 480px;\n        height: auto;\n        padding-top: calculateRem(20px);\n        margin: 0px;\n        max-width: 100%;\n        width: 100%;\n        position: relative;\n        overflow: auto;\n        box-shadow: none;\n        --background: transparent;\n        border-radius: 0;\n        .title {\n          h4 {\n            color: var((--ion-color-medium));\n            font-family: var(--ion-font-family);\n            margin: 0 0 30px;\n            text-transform: capitalize;\n            color: rgba(var(--ion-color-secondary-rgb), 1);\n            --height: auto;\n          }\n        }\n      }\n      form {\n        height: auto;\n        display: flex;\n        flex-direction: column;\n        margin-top: 0;\n        background: transparent;\n        ion-list {\n          background: transparent;\n          margin-bottom: 20px;\n        }\n        ion-item {\n          border: 1px solid transparent;\n          border-bottom-color: rgba(var(--ion-color-dark-rgb), 0.2);\n          border-radius: 0px;\n          --background: transparent;\n          --inner-padding-bottom: 0;\n          --padding-bottom: 0;\n          --inner-padding-top: 0;\n          --padding-top: 0;\n          --padding-start: 0;\n          --padding-end: 0;\n          height: auto;\n          --min-height: 50px;\n          margin: 0 0 10px;\n          --border-color: transparent;\n          &.item-has-focus,\n          &.item-has-value {\n            border-bottom-color: rgba(var(--ion-color-primary-rgb), 1);\n            --highlight-background: rgba(var(--ion-color-primary-rgb), 1);\n            ion-label {\n              margin-top: 0;\n              color: rgba(var(--ion-color-primary-rgb), 1);\n            }\n          }\n          &.ion-invalid {\n            --highlight-background: var(ion-color-danger);\n          }\n          ion-input {\n            --background: transparent;\n            --color: #000;\n            --inner-padding-bottom: 0;\n            --padding-bottom: 0;\n            --padding-top: 0px;\n            --inner-padding-top: 0;\n            margin: 0;\n            --placeholder-color: rgba(var(--ion-color-dark), 0.3);\n          }\n          ion-label {\n            --color: rgba(var(--ion-color-dark-rgb), 0.6);\n            --inner-padding-bottom: 0;\n            --padding-bottom: 0;\n            --inner-padding-top: 0;\n            --padding-top: 0;\n            margin-top: 0;\n            line-height: 1.3;\n          }\n        }\n        shc-validation-messages {\n          margin-top: 0;\n          margin-bottom: calculateRem(15px);\n          font-size: calculateRem(14px);\n        }\n        ion-toolbar {\n          --min-height: 80px;\n          ion-title {\n            padding: 0;\n            width: auto;\n            h3 {\n              margin: 0;\n              line-height: 1.3;\n            }\n          }\n        }\n      }\n    }\n  }\n  ion-alert {\n    background: var(--bg-app);\n    --background: var(--bg-app);\n    --background-color: var(--bg-app);\n    --ion-background-color: var(--bg-app);\n  }\n}\nion-footer {\n  position: absolute;\n  bottom: 0;\n  background: var(--bg-app);\n  background-position: bottom;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  @include tablet {\n    --background: transparent;\n    background: transparent;\n  }\n  ion-button {\n    &.theme-btn{\n      max-width: 463px;\n      margin: 16px auto;\n    }\n  }\n  @media(max-width: 575px){\n    ion-button {\n      &.theme-btn{\n        margin: 16px 10px;\n      }\n    }\n  }\n}\n.shipping-method {\n  --color: #000;\n}\n.select-icon{\n  display: none;\n}\n/* global.scss or component.scss */\n::ng-deep .custom-shipping-alert {\n  --border-color: \n}\n::ng-deep ion-alert .alert-wrapper {\n  border-radius: 16px;\n  background-color: #ffffff;\n  --background: #ffffff;\n  padding: 10px;\n}\n\n::ng-deep .custom-shipping-alert .alert-title {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n}\n\n::ng-deep .custom-shipping-alert .alert-radio-label {\n  font-size: 16px;\n  color: #222;\n  display: flex;\n  justify-content: space-between;\n}\n\n::ng-deep .custom-shipping-alert .alert-radio-inner {\n  background: var(--ion-color-primary);\n}\n\n::ng-deep .custom-shipping-alert .alert-button {\n  font-weight: bold;\n  color: var(--ion-color-primary);\n}\n/* In your component.scss */\n::ng-deep ion-alert {\n  --ion-color-step-850: #262626;\n  --ion-color-light-shade: #fffffff;\n  background: var(--ion-color-light-shade);\n--background: var(--ion-color-light-shade);\n  .shipping-method{\n    .alert-radio-label {\n      &.sc-ion-alert-md {\n        padding-inline-start: 35px;\n        font-size: 14px;\n        line-height: 18px;\n      }\n    }\n  }\n}\n\n\nion-select::part(icon) {\n  display: none; /* hide the icon */\n}\nion-select {\n  --border-color: transparent;\n}\n\n::ng-deep .custom-country-alert .alert-wrapper {\n  border-radius: 16px;\n}\n\n::ng-deep .custom-country-alert .alert-radio-inner {\n  background: var(--ion-color-primary);\n}\n\n::ng-deep .custom-country-alert .alert-radio-label {\n  font-size: 15px;\n  color: #222;\n}\n\n::ng-deep .custom-country-alert .alert-radio-icon {\n  border-color: var(--ion-color-primary);\n}\n\n::ng-deep .custom-country-alert .alert-button {\n  font-weight: bold;\n  color: var(--ion-color-primary);\n}\n\n\n.pill-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: var(--surface-card);\n  border-radius: 14px;\n  padding: 6px 16px;\n  min-height: 52px;\n}\n.pill-field--smart {\n  border: 1.5px solid var(--brand);\n  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));\n}\n.pill-label {\n  position: absolute;\n  top: 6px;\n  left: 16px;\n  font-size: 11px;\n  color: var(--text-secondary-token);\n}\n.pill-label--smart {\n  color: var(--brand);\n}\n.pill-input {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  padding-top: 16px;\n  font-size: 15px;\n  color: var(--text-primary-token);\n}\n.pill-chevron {\n  font-size: 16px;\n  color: var(--text-secondary-token);\n}\n.postal-house-row {\n  display: flex;\n  gap: 10px;\n  .pill-field {\n    flex: 1;\n  }\n}\n.pill-hint {\n  font-size: 11px;\n  color: var(--text-muted-token);\n  margin: -6px 0 10px 4px;\n}\n.shipping-methods-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary-token);\n  margin-bottom: 8px;\n}\n.shipping-method-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 0.5px solid var(--border-token);\n  border-radius: 14px;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n.shipping-method-card--selected {\n  border: 1.5px solid var(--brand);\n  background: color-mix(in srgb, var(--brand) 8%, var(--surface-card));\n}\n.shipping-method-name {\n  font-size: 14px;\n  color: var(--text-primary-token);\n}\n.shipping-method-price {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary-token);\n}\n.shipping-summary {\n  --background: transparent;\n  font-size: 12px;\n  color: var(--text-secondary-token);\n}\n\n.cost-breakdown {\n  padding: 4px 16px 0;\n\n  .cost-breakdown-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n    color: #777777;\n    padding: 2px 0;\n\n    &.cost-breakdown-total {\n      font-size: 16px;\n      font-weight: 700;\n      color: #1A1A1A;\n      margin-top: 4px;\n      padding-top: 6px;\n      border-top: 0.5px solid #ECECEC;\n    }\n  }\n}\n","@import \"../../theme/variables.scss\";\n@import \"../../theme/mixins.scss\";\n:host {\n  ion-header {\n    position: relative;\n    top: 0px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    --box-shadow: none;\n    box-shadow: none;\n    background: transparent;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    --background: transparent;\n    &:after {\n      display: none;\n    }\n    ion-toolbar {\n      --background: transparent;\n      --border-width: 0px;\n      color: var(--ion-color-secondary);\n      --min-height: 40px;\n      --padding-bottom: 5px;\n      --padding-top: 5px;\n      --padding-start: 20px;\n      --padding-end: 15px;\n      --box-shadow: none;\n      position: relative;\n      ion-buttons {\n        margin: 0;\n        ion-button {\n          margin: 0;\n          --background: transparent;\n          box-shadow: none;\n          --background-focused: transparent;\n          --background-focused-opacity: 0;\n          --background-hover: transparent;\n          --background-hover-opacity: 0;\n          --background-activated: transparent;\n          --background-activated-opacity: 0;\n          --border-radius: 0;\n          border-radius: 0;\n          --color: var(--ion-color-secondary);\n          --padding-end: 0;\n          --padding-top: 3px;\n          --padding-bottom: 3px;\n          --padding-start: 0;\n          font-size: 24px;\n          // padding: 0;\n          // &::part(native) {\n          //     padding: 0;\n          // }\n          .menu-btn {\n            position: relative;\n          }\n        }\n        ion-back-button {\n          --color: rgba(var(--ion-color-secondary-rgb), 0.9);\n        }\n      }\n      ion-title {\n        text-align: center;\n        font-size: calculateRem(24px);\n        font-weight: 600;\n        position: absolute;\n        left: 50%;\n        padding: 0;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        max-width: 200px;\n        line-height: 1.5;\n        &.logo {\n          position: absolute;\n          left: 50%;\n          right: 0;\n          top: 50%;\n          padding: 0;\n          transform: translate(-50%, -50%);\n          img {\n            max-width: calculateRem(131px);\n            height: auto;\n            display: inline-block;\n          }\n        }\n      }\n    }\n    &.greyHeader {\n      background: var(--ion-color-light-shade);\n      --background: var(--ion-color-light-shade);\n    }\n    // &.curved-header {\n    //     position: relative;\n    //     padding-top: 0px;\n    //     padding-bottom: 0px;\n    //     height: 75px;\n    //     display: flex;\n    //     align-items: center;\n    //     justify-content: stretch;\n    //     &:after {\n    //         background: var(--ion-color-primary-tint);\n    //         left: 25px;\n    //         right: 25px;\n    //         bottom: 0;\n    //         height: 15px;\n    //         border-radius: 24px 24px 0 0;\n    //         position: absolute;\n    //         width: auto;\n    //     }\n    //     ion-toolbar {\n    //         position: relative;\n    //         --min-height: 50px;\n    //         --background: transparent;\n    //         --border-width: 0px;\n    //         color: var(--ion-color-white);\n    //         --padding-top: 0;\n    //         --padding-bottom: 0px;\n    //         --padding-start: 18px;\n    //         --padding-end: 18px;\n    //         --box-shadow: none;\n    //         ion-buttons {\n    //             margin: 0px;\n    //             .menu-btn {}\n    //             ion-back-button {\n    //                 --border-radius: 4px;\n    //                 --background: rgba(255, 255, 255, 0.678);\n    //                 --min-height: 43px;\n    //                 --min-width: 45px;\n    //                 --border-radius: 14px;\n    //                 color: var(--ion-color-secondary);\n    //                 --icon-font-weight: 300;\n    //             }\n    //             ion-menu-button,\n    //             ion-button {\n    //                 --background: transparent;\n    //                 box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);\n    //                 --background-focused: #fff;\n    //                 --background-focused-opacity: 1;\n    //                 --background-hover: #fff;\n    //                 --background-hover-opacity: 1;\n    //                 --border-radius: 14px;\n    //                 border-radius: 14px;\n    //                 color: var(--ion-color-white);\n    //                 --padding-bottom: 0;\n    //                 --padding-top: 0;\n    //                 --padding-bottom: 0;\n    //                 --padding-bottom: 0;\n    //                 width: 45px;\n    //                 height: 43px;\n    //                 span {\n    //                     color: var(--ion-color-white);\n    //                 }\n    //                 &.bg-white {\n    //                     --border-radius: 4px;\n    //                     --background: rgba(255, 255, 255, 0.678);\n    //                     --min-height: 43px;\n    //                     --min-width: 45px;\n    //                     --border-radius: 14px;\n    //                     color: var(--ion-color-secondary);\n    //                     --icon-font-weight: 300;\n    //                 }\n    //             }\n    //         }\n    //         ion-title {\n    //             text-align: center;\n    //             color: var(--ion-color-white);\n    //             font-size: calculateRem(20px);\n    //             position: absolute;\n    //             left: 50%;\n    //             padding: 0;\n    //             top: 50%;\n    //             transform: translate(-50%, -50%);\n    //             max-width: 200px;\n    //             line-height: 1.5;\n    //         }\n    //         ion-avatar {\n    //             width: 45px;\n    //             height: 45px;\n    //             img {\n    //                 height: auto;\n    //                 max-width: 100%;\n    //             }\n    //         }\n    //     }\n    // }\n  }\n  ion-content {\n    --padding-top: 0;\n    --offset-bottom: -100px;\n  }\n}\n","$breakpoint-phone-xs: 375px;\n$breakpoint-phone-xs2: 400px;\n\n$breakpoint-phone-sm: 480px;\n$breakpoint-phone-md: 567px;\n$breakpoint-phone: 767px;\n$breakpoint-tablet: 992px;\n$breakpoint-desktop-sm: 1080px;\n$breakpoint-desktop: 1200px;\n$breakpoint-desktop-lg: 1440px;\n//Default font size on html element is 100%, equivalent to 16px;\n@function calculateRem($size) {\n    $remSize: calc($size / 18px);\n    @return #{$remSize}rem;\n}\n\n//  Breakout mixins\n@mixin desktopLgOnly {\n    @media screen and (max-width: $breakpoint-desktop-lg) {\n        @content;\n    }\n}\n\n@mixin desktopLg {\n    @media screen and (min-width: $breakpoint-desktop-lg) {\n        @content;\n    }\n}\n\n@mixin desktopOnly {\n    @media screen and (max-width: $breakpoint-desktop) {\n        @content;\n    }\n}\n\n@mixin desktop {\n    @media screen and (min-width: $breakpoint-desktop) {\n        @content;\n    }\n}\n\n@mixin desktopSmOnly {\n    @media screen and (max-width: $breakpoint-desktop-sm) {\n        @content;\n    }\n}\n\n@mixin desktopSm {\n    @media screen and (min-width: $breakpoint-desktop-sm) {\n        @content;\n    }\n}\n\n@mixin tabletOnly {\n    @media screen and (max-width: $breakpoint-tablet) {\n        @content;\n    }\n}\n\n@mixin tablet {\n    @media screen and (min-width: $breakpoint-tablet) {\n        @content;\n    }\n}\n\n@mixin phoneOnly {\n    @media screen and (max-width: $breakpoint-phone) {\n        @content;\n    }\n}\n\n@mixin phone {\n    @media screen and (min-width: $breakpoint-phone) {\n        @content;\n    }\n}\n\n@mixin phoneMdOnly {\n    @media screen and (max-width: $breakpoint-phone-md) {\n        @content;\n    }\n}\n\n@mixin phoneMd {\n    @media screen and (min-width: $breakpoint-phone-md) {\n        @content;\n    }\n}\n\n@mixin phoneSmOnly {\n    @media screen and (max-width: $breakpoint-phone-sm) {\n        @content;\n    }\n}\n\n@mixin phoneSm {\n    @media screen and (min-width: $breakpoint-phone-sm) {\n        @content;\n    }\n}\n\n@mixin phoneXsOnly {\n    @media screen and (max-width: $breakpoint-phone-xs) {\n        @content;\n    }\n}\n\n@mixin phoneXs2Only {\n  @media screen and (max-width: $breakpoint-phone-xs2) {\n      @content;\n  }\n}\n\n@mixin phoneXs {\n    @media screen and (min-width: $breakpoint-phone-xs) {\n        @content;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
